import RegistrationUser from './RegistrationUserAdmin';

export default RegistrationUser;
